var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Accordion } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { EDataSource, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import Loader from "@frameworks/shared-library/components/Loader";
import GroupFilter from "./GroupFilter";
export var GenericFilter = function (props) {
    var _a;
    var onChange = function (productID, subProductId, checked) {
        props === null || props === void 0 ? void 0 : props.setFilterList(function (prevFilterList) {
            var _a;
            return (_a = props === null || props === void 0 ? void 0 : props.filterList) === null || _a === void 0 ? void 0 : _a.map(function (product) {
                var _a;
                if (product.id == productID) {
                    var updatedProduct = __assign(__assign({}, product), { subList: product.subList.map(function (subProduct) {
                            return (subProduct === null || subProduct === void 0 ? void 0 : subProduct.id) == subProductId
                                ? __assign(__assign({}, subProduct), { checked: checked }) : subProduct;
                        }) });
                    updatedProduct.checked = (_a = updatedProduct === null || updatedProduct === void 0 ? void 0 : updatedProduct.subList) === null || _a === void 0 ? void 0 : _a.some(function (subproduct) { return subproduct.checked; });
                    return updatedProduct;
                }
                else {
                    return product;
                }
            });
        });
    };
    var clearall = function () {
        // let updateFilter = props.filterList.map((singleFilter) => {
        //   if (singleFilter.subList.length > 0) {
        //     return {
        //       ...singleFilter,
        //       subList: singleFilter.subList.map((subItem) => ({
        //         ...subItem,
        //         checked: false,
        //       })),
        //     };
        //   } else {
        //     return singleFilter;
        //   }
        // });
        // props.setFilterList(updateFilter);
        props.onClear();
    };
    var getSubProducts = function (productID, selectAll) {
        var _a, _b;
        var product = props === null || props === void 0 ? void 0 : props.filterList.find(function (product) { return product.id === productID; });
        var subProductList = (_b = (_a = props === null || props === void 0 ? void 0 : props.retainedNRProductList) === null || _a === void 0 ? void 0 : _a.find(function (product) { return product.id === productID; })) === null || _b === void 0 ? void 0 : _b.subList;
        // if (selectAll !== false) {
        props
            .getFilterData(EDataSource.SUBPRODUCT, productID)
            .then(function (subProducts) {
            var _a, _b;
            if (((_a = subProducts === null || subProducts === void 0 ? void 0 : subProducts.filterData) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var products = (_b = props === null || props === void 0 ? void 0 : props.filterList) === null || _b === void 0 ? void 0 : _b.map(function (singleProduct) {
                    var subFilter = subProducts.filterData.map(function (filter) {
                        var _a, _b;
                        return {
                            id: filter.id,
                            name: filter.name,
                            checked: selectAll
                                ? selectAll
                                : (_b = (_a = subProductList === null || subProductList === void 0 ? void 0 : subProductList.find(function (subProduct) { return subProduct.id === filter.id; })) === null || _a === void 0 ? void 0 : _a.checked) !== null && _b !== void 0 ? _b : false,
                        };
                    });
                    return singleProduct.id === productID
                        ? __assign(__assign({}, singleProduct), { subList: subFilter }) : singleProduct;
                });
                props === null || props === void 0 ? void 0 : props.setFilterList(products);
            }
        });
        // } else {
        //   product.subList = product?.subList?.map((subProduct) => ({
        //     ...subProduct,
        //     checked: selectAll,
        //   }));
        //   let products = props?.filterList?.map((singleProduct) => {
        //     return singleProduct.id === productID
        //       ? { ...singleProduct, subList: product.subList }
        //       : singleProduct;
        //   });
        //   props?.setFilterList(products);
        // }
    };
    var selectedAllHandler = function (e, id) {
        if (e && id) {
            props === null || props === void 0 ? void 0 : props.setFilterList(function (prevState) {
                return prevState === null || prevState === void 0 ? void 0 : prevState.map(function (filter) {
                    var _a;
                    if (filter.id === id) {
                        filter.checked = e.target.checked;
                        (_a = filter === null || filter === void 0 ? void 0 : filter.subList) === null || _a === void 0 ? void 0 : _a.map(function (x) {
                            x.checked = e.target.checked;
                        });
                    }
                    return filter;
                });
            });
        }
    };
    return (React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.openFilter) ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "filterasset-drop DMSan_16_700 txt_blackOne1 ".concat(props.externalClassName) },
            "Select Products",
            React.createElement("div", { className: "outer-div" },
                React.createElement(Accordion, { className: "filter-accordion" }, (props === null || props === void 0 ? void 0 : props.filterList.length) > 0 ? ((_a = props === null || props === void 0 ? void 0 : props.filterList) === null || _a === void 0 ? void 0 : _a.map(function (singleFilter, idx) { return (React.createElement(GroupFilter, { singleFilter: singleFilter, getSubProducts: getSubProducts, idx: idx, onChange: onChange, selectedAllHandler: selectedAllHandler })); })) : (React.createElement(Loader, null)))),
            React.createElement("div", { className: "funds filterasset-drop-footer" },
                React.createElement(EdButton, { className: "filter-button clear_all", value: "Clear All", onClick: function () {
                        clearall();
                        props.setOpenFilter(false);
                    }, btnTyp: "midnight-blue-border" }),
                React.createElement(EdButton, { className: "filter-button aply-btn", value: "Apply", onClick: function () {
                        props.onSubmit();
                        props.setOpenFilter(false);
                    }, btnTyp: "midnight-blue" }))))) : ("")));
};
